import dayjs from 'dayjs'

export const convertToDateTime = (date) => (date ? dayjs.utc(date).format('L LT') : 'N/A')

export const convertToWithTimezone = (date) => (date ? dayjs.utc(date).format('MMM DD, YYYY [at] h:mm A [UTC]') : 'N/A')

export const convertToFromNow = (date) => dayjs.utc(date).fromNow()

export const convertToShorthand = (date) => (date ? dayjs.utc(date).format('L') : 'N/A')

export const convertToShorthandWithTime = (date) => (date ? dayjs.utc(date).format('L h:mm A') : 'N/A')

export const convertToShorthandWithTimezone = (date) => (date ? dayjs.utc(date).format('L h:mm A') + ' UTC' : 'N/A')

export const convertToMonth = (date) => (date ? dayjs.utc(date).format('MMM YYYY') : 'N/A')

export const convertToLongDate = (date) => (date ? dayjs.utc(date).format('MMM D, YYYY') : 'N/A')
